export var TrafficChannelChange;
(function (TrafficChannelChange) {
    TrafficChannelChange[TrafficChannelChange["OnlyForAffiliate"] = 0] = "OnlyForAffiliate";
    TrafficChannelChange[TrafficChannelChange["ForAffiliateAndHisCampaigns"] = 1] = "ForAffiliateAndHisCampaigns";
})(TrafficChannelChange || (TrafficChannelChange = {}));
